<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('course.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item>{{ $t('course.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item>{{ $t('lecturer.detail.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <lecturer-info :lecturer="lecturer"></lecturer-info>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-button :to="{ name: 'today-courses' }" variant="primary" block>{{ $t('course.detail.button.view-more.label') }}</b-button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { LinkPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'
import { NavPlugin } from 'bootstrap-vue'

import LecturerInfo from '@/components/info/LecturerInfo'

import i18n from '@/plugins/i18n.js'

import LecturerApiService from '@/services/budaedu-api-services/lecturer-api-service.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ButtonPlugin)
Vue.use(IconsPlugin)
Vue.use(LinkPlugin)
Vue.use(ModalPlugin)
Vue.use(NavPlugin)

Vue.use(LecturerApiService)

export default {
  i18n,
  name: 'lecturer',
  props: {
    id: {
      type: Number,
      require: true
    }
  },
  data() {
    return {
      lecturer: null
    }
  },
  methods: {
    async setLecturer() {
      const lecturer_item = await this.$lecturerApiService.getById(this.id)
      let lecturer = lecturer_item.data

      const lecturer_photo_item = await this.$lecturerApiService.getPhoto(lecturer)
      lecturer.photo = lecturer_photo_item ? lecturer_photo_item.data : {}

      this.lecturer = lecturer
    }
  },
  async created() {
    //alert(`Vue version : ${Vue.version}`);
    await this.setLecturer()
  },
  components: {
    LecturerInfo
  },
  metaInfo() {
    const title = this.lecturer
      ? `${this.lecturer.lecr_full_name}`
      : `${this.$t('lecturer.detail.title')}`
    
    return {
      title: title,
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
};
</script>